export const autoDefineElements = globalThis.$lume?.autoDefineElements ?? true;
//# sourceMappingURL=LumeConfig.js.map